var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var parseTime = function (milliTime) {
    var second = 1000;
    var minute = 60 * 1000;
    var hour = 60 * 60 * 1000;
    var hours = 0, minutes = 0, seconds = 0;
    var rest = milliTime;
    var text = '';
    var haveHours = milliTime / hour > 1;
    if (haveHours) {
        hours = Math.floor(milliTime / hour);
        rest = rest % hour;
        text = "".concat(hours, ":");
    }
    var haveMinutes = rest / minute > 1;
    if (haveMinutes) {
        minutes = Math.floor(rest / minute);
        rest = rest % minute;
        text = minutes > 9 ? "".concat(text).concat(minutes, ":") : "".concat(text, "0").concat(minutes, ":");
    }
    else {
        text = "".concat(text, "00:");
    }
    var haveSeconds = milliTime / second > 1;
    if (haveSeconds) {
        seconds = Math.floor(rest / second);
        text = seconds > 9 ? "".concat(text).concat(seconds) : "".concat(text, "0").concat(seconds);
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        toText: text,
    };
};
/*
start and pause array join all range and check timerange cover
 */
export var sliceToTimeRange = function (duration, step) {
    var timeBySlice = duration / step;
    var timeRanges = [];
    for (var i = 0; i < 20; i++) {
        if (i === 19) {
            timeRanges.push({ start: i * timeBySlice, end: (i + 1) * timeBySlice });
        }
        else {
            timeRanges.push({ start: i * timeBySlice, end: (i + 1) * timeBySlice });
        }
    }
    return timeRanges;
};
export var joinTimeRanges = function (timeRange) {
    return timeRange.reduce(function (acc, curr) {
        var start = curr.start, end = curr.end;
        var isOverRange = function (range) {
            return (range.start <= start && start <= range.end) ||
                (end >= range.start && range.start >= start) ||
                (start <= range.start && range.end <= end);
        };
        var overExistingRange = acc.filter(isOverRange);
        if (overExistingRange.length > 1) {
            // plusieurs superposition (on diminue le meme nombre d'item dans le tableau)
            var min_1 = Math.min.apply(Math, __spreadArray(__spreadArray([], overExistingRange.map(function (item) { return item.start; }), false), [start], false));
            var max_1 = Math.max.apply(Math, __spreadArray(__spreadArray([], overExistingRange.map(function (item) { return item.end; }), false), [end], false));
            var test_1 = acc.filter(function (item) { return item.start > max_1 || item.end < min_1; });
            return __spreadArray(__spreadArray([], test_1, true), [{ start: min_1, end: max_1 }], false);
        }
        else if (overExistingRange.length === 1) {
            // une seule superposition (on garde le meme nombre d'item dans le tableau)
            return acc.map(function (range) {
                if (isOverRange(range)) {
                    var min = Math.min(range.start, start);
                    var max = Math.max(range.end, end);
                    return { start: min, end: max };
                }
                return range;
            });
        }
        else {
            // on ajoute car aucune superposition
            return __spreadArray(__spreadArray([], acc, true), [curr], false);
        }
    }, []);
};
